import OperDashboardChart from './operDashboardChart';

const OperDashboard = ({ item, chngState }) => {
  return (
    <>
      <table className="MapRightSubTitle">
        <tr>
          <th>운영현황</th>
          <td>(단위: 명)</td>
        </tr>
      </table>
      <div className="graphBgA">
        <OperDashboardChart item={item} chngState={chngState}></OperDashboardChart>
      </div>
    </>
  );
};

export default OperDashboard;
